module.exports = __webpack_public_path__ + "img/samsung-icon.86b7f446.svg";